define('modules/affiliation-requests/stores/affiliation-request-store',['require','underscore','evertrue','modules/affiliation-requests/sources/affiliation-request-source','et_flux'],function(require) {
  var AffiliationRequestSource, EverTrue, createStore, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  AffiliationRequestSource = require("modules/affiliation-requests/sources/affiliation-request-source");
  createStore = require("et_flux").createStore;
  return createStore("AffiliationRequestStore", {
    getInitialState: function() {
      return {
        loading: false,
        filter_type: null,
        sort_param: "created_at,desc",
        requests: {},
        has_pending_requests: false
      };
    },
    registerActions: function() {
      this.on(AffiliationRequestSource.actions.loadingRequests, this.respondToLoadingRequests);
      this.on(AffiliationRequestSource.actions.setFilterType, this.respondToSetFilterType);
      this.on(AffiliationRequestSource.actions.setSortParam, this.respondToSetSortParam);
      this.on(AffiliationRequestSource.actions.fetchedAffiliationRequests, this.respondToFetchedAffiliationRequests);
      this.on(AffiliationRequestSource.actions.hasPendingRequests, this.respondToHasPendingRequests);
      return this.on(AffiliationRequestSource.actions.loadMoreRequests, this.respondToLoadMoreRequests);
    },
    respondToLoadingRequests: function(loading) {
      return this.setState({
        loading: loading
      });
    },
    respondToSetFilterType: function(type) {
      var requests, sort_param, _ref, _ref1;
      this.setState({
        filter_type: type
      });
      requests = EverTrue.cloneData(this.getState("requests"));
      sort_param = this.getState("sort_param");
      if (!requests[type] || _.isEmpty((_ref = requests[type]) != null ? _ref.items : void 0)) {
        return AffiliationRequestSource.fetchAffiliationRequests(type, sort_param);
      } else if (!_.isEqual((_ref1 = requests[type]) != null ? _ref1.sort : void 0, sort_param)) {
        requests[type].items = [];
        this.setState({
          requests: requests
        });
        return AffiliationRequestSource.fetchAffiliationRequests(type, sort_param);
      }
    },
    respondToSetSortParam: function(sort_param) {
      var requests, type;
      requests = EverTrue.cloneData(this.getState("requests"));
      type = this.getState("filter_type");
      if (!_.isEqual(sort_param, this.getState("sort_param"))) {
        requests[type].items = [];
        this.setState({
          sort_param: sort_param,
          requests: requests
        });
        return AffiliationRequestSource.fetchAffiliationRequests(type, sort_param);
      }
    },
    respondToFetchedAffiliationRequests: function(data) {
      var clean_requests, filter_type, items, limit, more_to_load, offset, parsed_requests, requests, sort, _ref;
      items = data.items, filter_type = data.filter_type, sort = data.sort, limit = data.limit, offset = data.offset;
      requests = EverTrue.cloneData(this.getState("requests"));
      more_to_load = limit === items.length ? true : false;
      parsed_requests = _.map(items, function(request) {
        var name, _ref;
        if ((_ref = request.user) != null ? _ref.name : void 0) {
          name = request.user.name;
          request.user.search_name = name.replace("/", " ");
        }
        return request;
      });
      if (!((_ref = EverTrue.User) != null ? _ref.get("super_user") : void 0)) {
        clean_requests = _.filter(parsed_requests, function(request) {
          var email, _ref1;
          email = ((_ref1 = request.user) != null ? _ref1.email : void 0) || "";
          return (email != null ? email.indexOf("@evertrue.com") : void 0) < 0;
        });
        parsed_requests = clean_requests;
      }
      if (requests[filter_type]) {
        _.each(parsed_requests, function(request) {
          items = requests[filter_type].items;
          if (!_.findWhere(items, {
            id: request.id
          })) {
            return items.push(request);
          }
        });
      } else {
        requests[filter_type] = {
          items: parsed_requests
        };
      }
      requests[filter_type] = _.extend(requests[filter_type], {
        more_to_load: more_to_load,
        offset: offset,
        sort: sort
      });
      return this.setState({
        requests: requests
      });
    },
    respondToHasPendingRequests: function(bool) {
      return this.setState({
        has_pending_requests: bool
      });
    },
    respondToLoadMoreRequests: function() {
      var offset, requests, type, _ref, _ref1;
      requests = EverTrue.cloneData(this.getState("requests"));
      type = this.getState("filter_type");
      offset = ((_ref = requests[type]) != null ? (_ref1 = _ref.items) != null ? _ref1.length : void 0 : void 0) + 1;
      return AffiliationRequestSource.fetchAffiliationRequests(type, this.getState("sort_param"), offset);
    },
    api: {
      getLoading: function() {
        return this.getState("loading");
      },
      getRequests: function() {
        return this.getState("requests")[this.getState("filter_type")];
      },
      getHasPendingRequests: function() {
        return this.getState("has_pending_requests");
      },
      getFilterType: function() {
        return this.getState("filter_type");
      },
      getSortParam: function() {
        return this.getState("sort_param");
      }
    }
  });
});

//# sourceMappingURL=affiliation-request-store.js.map
;
